var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Box from '../box/Box';
import Icon from '../icon/Icon';
import Text from '../text';
import { IoIosCheckmark } from 'react-icons/io';
export function Tag(_a) {
    var label = _a.label, icon = _a.icon, _b = _a.color, color = _b === void 0 ? 'grays.6' : _b, _c = _a.bg, bg = _c === void 0 ? 'grays.0' : _c, rest = __rest(_a, ["label", "icon", "color", "bg"]);
    return (React.createElement(Box, __assign({}, rest, { display: "inline-flex", bg: bg, alignItems: "center", borderRadius: "12px" }),
        React.createElement(Text, { fontSize: 0, color: color, pl: 2 }, label),
        React.createElement(Icon, { icon: icon, color: color, size: 24 })));
}
export default Tag;
export var CheckMarkTag = function (props) { return React.createElement(Tag, __assign({}, props, { icon: IoIosCheckmark })); };
//# sourceMappingURL=Tag.js.map